export default __webpack_public_path__ + "672302bf37d6b501b366dbf9ededf22c.svg";